import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import Grid from '@material-ui/core/Grid';
import { API_URL } from '../common/Constants';
import axios from 'axios';
import './introduction.css';

// import TitleText from '../common/TitleText';
// import Pagination from './Pagination';
// import Drawings from './Drawings';

const styles = (theme) => ({
  content_bg: {
    backgroundColor: '#fff',
    margin: '0 auto',
    width: '930px',
    padding: '0 80px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 30px',
      width: '100%',
    },
  },

  exImg: {
    width: '100%',
    height: '190px',
    margin: 0,
    borderRadius: '12px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: '157px',
    },
  },

  examplesWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  examplesMob: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  circlesWeb: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  circlesMobile: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
});
const examples = [
  { img: './images/stamp/ex1@2x.png', text: '치악산둘레길' },
  { img: './images/stamp/ex2@2x.png', text: '송파둘레길' },
  { img: './images/stamp/ex3@2x.png', text: '수원화성성곽길' },
  { img: './images/stamp/ex4@2x.png', text: '청년 김대건의 길을 걷다' },
  { img: './images/stamp/ex5@2x.png', text: '등대 스탬프투어' },
  { img: './images/stamp/ex6@2x.png', text: '부산갈맷길' },
  { img: './images/stamp/ex7@2x.png', text: '천연기념물센터' },
  { img: './images/stamp/ex8@2x.png', text: '예산 스탬프투어' },
  { img: './images/stamp/ex9@2x.png', text: '구리둘레길' },
];

class Stamp extends Component {
  constructor(props) {
    super(props);

    this.state = { currentPage: 0, perPage: 4, imgData: '' };
    this.changePage = this.changePage.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${API_URL}/admin/menuInfo`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        // console.log(response.data);
        let _result = response.data;
        this.setState({ imgData: _result });
        // console.log('imgData', this.state.imgData);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {}
  changePage(e, direction) {
    if (direction === 'prev') {
      if (this.state.currentPage > 0) {
        this.setState({ currentPage: this.state.currentPage - 1 });
      }
    } else {
      if (this.state.currentPage < parseInt(examples.length / this.state.perPage)) {
        this.setState({ currentPage: this.state.currentPage + 1 });
      }
    }
  }
  render() {
    // const { currentPage, perPage } = this.state;
    // const indexFirst = perPage * currentPage;
    // const indexLast = indexFirst + perPage;
    // const { classes } = this.props;
    // const showExamples = examples.slice(indexFirst, indexLast);

    return (
      <React.Fragment>
        <Topbar />
        <div className="dw_bg">
          <Grid
            id="index_grid"
            container
            justify="flex-start"
            style={{ padding: '2vh calc(2vw - 30px)', color: '#1b1d54', fontSize: '1.3em' }}
          >
            <b>제품소개 〉 스탬프</b>
          </Grid>
          <div className="bg_inner">
            <img
              src={this.state.imgData.m2_2}
              onContextMenu={(e) => e.preventDefault()} //스탬프 이미지 우클릭 다운로드 방지
              alt={'img'}
              style={{ width: '100%', paddingTop: '4vh', WebkitTouchCallout: 'none' }}
            />
            {/* <TitleText title="스탬프" />
            <p align="center" className="mainTxt">
              수년간의 연구와
              <br className={classes.examplesMob} />
              개발의 결실
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/stamp/circles@2x.png" alt="" className={classes.circlesWeb} style={{ width: '60%', padding: '30px 0', WebkitTouchCallout: 'none' }} />
              <img
                src="./images/stamp/circles@3x.png"
                alt=""
                className={classes.circlesMobile}
                style={{ width: '90%', padding: '30px 0', WebkitTouchCallout: 'none' }}
              />
            </Grid>

            <p component="p" gutterBottom align="center" className="descTxt">
              8가지 특허 기술을 활용한
              <br /> 차별화된 스탬프 거치대(고정 원터치 방식)를 제공하여
              <br /> 스탬프 훼손, 도난 등
              <span style={{ color: '#0071bc' }}>
                기존 스탬프투어의 문제점을
                <br /> 완벽하게 해결할 수 있는 서비스를 제공
              </span>
              합니다.
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/stamp/stamp.png" alt="" className="mainImg" style={{ width: '100%', WebkitTouchCallout: 'none' }} />
            </Grid>
            <Grid container direction="column" justify="center" className="grayBox">
              <p className="infoTxt">
                <img src="./images/stampbook/ic_info.png" alt="infomation" style={{WebkitTouchCallout: 'none'}} /> <b>초정밀, 비증발성 특수잉크 충전형 방수스탬프</b>
              </p>
              <ul className="features">
                <li>
                  벽면 부착 또는 천장부착 <b>보안형</b>
                </li>
                <li>
                  <b>스테인레스 재질로 녹슬지 않으며 강한 내구성</b>을 지니고 있습니다.
                </li>
                <li>
                  <b>반영구적인 탄성구조의 결속장치를 부착</b>합니다. <b>(특허)</b>
                </li>
                <li>
                  <b>유지관리가 편리</b>합니다. (<b>시간적, 인적 경비절감 효과</b>가 큼)
                </li>
                <li>
                  <b>1회 충전으로 약 2~3만번 이상 날인</b> (비증발성 특수잉크 사용)
                </li>
                <li>
                  물에 강하여 날인이미지에 <b>물이 닿아도 번지지 않습니다.</b>
                </li>
                <li>
                  <b>영하 30도에서도 얼지 않습니다.</b>
                </li>
              </ul>
            </Grid>

            <Grid>
              <Pagination
                pageText="설치 사례"
                examples={examples}
                currentPage={this.state.currentPage}
                perPage={this.state.perPage}
                changePage={this.changePage}
              />
            </Grid>
            <Grid container className={classes.examplesMob} spacing={3} style={{ paddingTop: '20px' }}>
              {showExamples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" xs={6}>
                  <p style={{ width: '100%', margin: 0, overflowY: 'hidden', overflow: 'hidden' }}>
                    <img src={example.img} alt="infomation" style={{ width: '100%', borderRadius: '12px', WebkitTouchCallout: 'none' }} />
                  </p>
                  <p style={{ fontSize: '1.1em', marginBottom: 0, wordBreak: 'keep-all', textAlign: 'center' }}>{example.text}</p>
                </Grid>
              ))}
            </Grid>
            <Grid container className={classes.examplesWeb} spacing={3} style={{ paddingTop: '40px' }}>
              {examples.map((example, idx) => (
                <Grid key={idx} container item direction="column" alignItems="center" sm={4}>
                  <p className={classes.exImg}>
                    <img
                      src={example.img}
                      alt="infomation"
                      style={{ width: '100%', WebkitTouchCallout: 'none' }}
                      onContextMenu={(e) => e.preventDefault()} //스탬프 이미지 우클릭 다운로드 방지
                    />
                  </p>
                  <p className="exTxt">{example.text}</p>
                </Grid>
              ))}
            </Grid>
            <TitleText title="날인 이미지" />
            <p align="center" className="mainTxt">
              완벽한 핸드 드로잉으로 맞춤형 표현
            </p>
            <Grid container justify="center" alignItems="center">
              <img src="./images/stamp/circles2@2x.png" alt="" className={classes.circlesWeb} style={{ width: '60%', padding: '30px 0', WebkitTouchCallout: 'none' }} />
              <img
                src="./images/stamp/circles2@3x.png"
                alt=""
                className={classes.circlesMobile}
                style={{ width: '90%', padding: '30px 0', WebkitTouchCallout: 'none' }}
              />
            </Grid>
            <p align="center" className="descTxt">
              스탬프를 날인 할때 찍혀 나오는 날인이미지는
              <br />
              스탬프 전문 디자이너가 직접 수작업으로 표현합니다.
              <br /> 고객의 맞춤형으로 여러가지 그림체로 표현이 가능하며
              <br /> 다양한 사이즈와 네가지 색상의 스탬프로 제작이 가능합니다.
            </p>
            <Grid container justify="center" alignItems="center">
              <img
                src="./images/stamp/drawing.png"
                alt=""
                style={{ width: '100%', WebkitTouchCallout: 'none' }}
                className="mainImg"
                onContextMenu={(e) => e.preventDefault()} //스탬프 이미지 우클릭 다운로드 방지
              />
            </Grid>
            <Grid container direction="column" justify="center" className="grayBox">
              <p className="infoTxt">
                <img src="./images/stampbook/ic_info.png" alt="infomation" style={{ verticalAlign: 'bottom', WebkitTouchCallout: 'none' }} />{' '}
                <b>여러가지 드로잉 방식으로 스탬프이미지를 구현</b>
              </p>
              <ul className="features">
                <li>
                  <b>세밀 핸드 드로잉으로 회화적인 표현을 제공</b>할 수 있습니다.
                </li>
                <li>
                  <b>수작업</b>으로 인해 <b>사실적이고 섬세한 표현이 가능</b>합니다.
                </li>
                <li>
                  <b>600dpi의 고해상도 이미지를 구현</b>할 수 있습니다.
                </li>
                <li>
                  <b>예술적 표현을 실현</b>하여 스탬프의 가치를 높입니다.
                </li>
                <li>
                  <b>컴퓨터 편집과 더불어 시너지 효과</b>를 나타낼 수 있습니다.
                </li>
                <li>
                  사진 자체를 재편집하여 <b>뚜렷한 날인이미지를 표현</b>할 수 있습니다.
                </li>
                <li>
                  <b>원하는 그림체로 무엇이든 표현이 가능</b>합니다.
                </li>
              </ul>
            </Grid>

            <Grid container>
              <Drawings pageText="제작 사례" />
            </Grid> */}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(Stamp));
